import config from "@/config";

export const setTit = () => {
    // let keyword = window.location.href;

    // if( keyword.indexOf('hhh5') > -1 ){
    //     return '恒好用车'
    // }else if( keyword.indexOf('tgh5') > -1 ){
    //     return '同港出行'
    // }else if( keyword.indexOf('jbh5') > -1 ){
    //     return '900出行'
    // }else if( keyword.indexOf('qxh5') > -1 ){
    //     return '前行出行'
    // }else if( keyword.indexOf('ymh5') > -1 ){
    //     return '益民出行'
    // }else if( keyword.indexOf('yyh5') > -1 ){
    //     return '易约出行'
    // }else if( keyword.indexOf('sdh5') > -1 ){
    //     return '顺道好司机'
    // }else if( keyword.indexOf('fch5') > -1 ){
    //     return '风驰出行'
    // }else if( keyword.indexOf('fzxh5') > -1 ){
    //     return '方舟行'
    // }else{
    //     return '当前平台'
    // }
    return config.TITLE
}